import { onReady } from '../base/init.js';

// deg360 — просмотр модели: 360°-вращение (drag) или статичное фото (count<=1),
// с колорпикером и опциональным селектором комплектаций (grades → набор кадров {grade}/{color}).

// Реестр вертушек: качественный видимый кадр прогревается во ВСЕХ карточках
// (по одному кадру на карточку) по полной загрузке страницы; ховер/тач на любой
// карточке — ранний триггер. Объявлен ДО onReady: defer-бандл исполняется при
// readyState=interactive, и onReady зовёт initRotator синхронно (иначе TDZ).
// Полный набор из 36 кадров карточка догружает при собственном ховере/таче.
const rotatorWarmers = [];
let warmedAll = false;
function warmAllRotators() {
  if (warmedAll) return;
  warmedAll = true;
  rotatorWarmers.forEach((warm) => warm());
}

onReady(() => {
  document.querySelectorAll('.js-rotator').forEach(initRotator);
  // Лёгкие обложки — только до полной загрузки страницы: по load подменяем
  // качественными кадрами во всех вертушках, не дожидаясь взаимодействия
  if (document.readyState === 'complete') {
    warmAllRotators();
  } else {
    window.addEventListener('load', warmAllRotators, { once: true });
  }
});

function initRotator(rotator) {
  const stage = rotator.querySelector('.js-rotator-stage');
  const img = rotator.querySelector('.js-rotator-img');
  if (!stage || !img) return;

  const base = (rotator.getAttribute('data-base') || '').replace(/\/+$/, '');
  const model = rotator.getAttribute('data-model');
  const count = parseInt(rotator.getAttribute('data-count'), 10) || 1;
  const initialFrame = parseInt(rotator.getAttribute('data-start'), 10) || 1;
  let color = rotator.getAttribute('data-color');
  let edition = rotator.getAttribute('data-edition') || '';

  let frame = initialFrame;
  const sets = new Map();

  const CHUNK = 6;
  const NEIGHBORS = 2;
  const idle =
    typeof window.requestIdleCallback === 'function'
      ? (cb) => window.requestIdleCallback(cb, { timeout: 500 })
      : (cb) => setTimeout(cb, 32);

  const setKey = (c) => `${edition}|${c}`;

  // Размер набора кадров под фактический рендер (контейнер CSS × DPR):
  // подкаталоги 644/ и 1280/ генерятся из мастеров 1920-2100px (см. session
  // 2026-06-09). Полные мастера — только для гипотетических экранов > 1280.
  let sizeDir = null; // лениво: на момент init layout мог быть не готов
  function resolveSizeDir() {
    if (sizeDir !== null) return sizeDir;
    const w = stage.clientWidth || 644;
    const need = Math.ceil(w * Math.min(window.devicePixelRatio || 1, 3));
    sizeDir = need <= 644 ? '644/' : need <= 1280 ? '1280/' : '';
    return sizeDir;
  }

  const frameUrl = (c, n) => `${base}/${model}/360/${edition ? `${edition}/` : ''}${c}/${resolveSizeDir()}${n}.webp`;

  function frameSet(c) {
    const k = setKey(c);
    let set = sets.get(k);
    if (!set) {
      set = { frames: [], done: false };
      sets.set(k, set);
    }
    return set;
  }

  function loadFrame(set, c, idx) {
    if (set.frames[idx]) return;
    const im = new Image();
    im.decoding = 'async';
    im.src = frameUrl(c, idx);
    set.frames[idx] = im;
  }

  function preload(c) {
    const set = frameSet(c);
    if (set.done) return;
    set.done = true;
    loadFrame(set, c, frame);
    for (let d = 1; d <= NEIGHBORS; d += 1) {
      loadFrame(set, c, ((frame - 1 + d) % count) + 1);
      loadFrame(set, c, ((frame - 1 - d + count) % count) + 1);
    }
    let i = 1;
    const step = () => {
      if (sets.get(setKey(c)) !== set) return;
      let n = 0;
      while (i <= count && n < CHUNK) {
        if (!set.frames[i]) {
          loadFrame(set, c, i);
          n += 1;
        }
        i += 1;
      }
      if (i <= count) idle(step);
    };
    idle(step);
  }

  // Апгрейд видимой картинки: ховер/первое касание = намерение пользователя —
  // не ждём начала вращения, лёгкая обложка (644w) тихо подменяется полноразмерным
  // кадром, как только он докачался (preload уже стартовал, доп. трафика нет).
  function upgradeVisible() {
    const c = color;
    const idx = frame;
    const set = frameSet(c);
    loadFrame(set, c, idx);
    const im = set.frames[idx];
    if (!im || img.src === im.src) return;
    const apply = () => {
      if (color === c && frame === idx && im.naturalWidth) img.src = im.src;
    };
    if (im.complete && im.naturalWidth) {
      apply();
      return;
    }
    im.addEventListener('load', apply, { once: true });
  }

  function nearestSrc(set, idx) {
    const exact = set.frames[idx];
    if (exact && exact.src) return exact.src;
    for (let d = 1; d < count; d += 1) {
      const f = set.frames[((idx - 1 + d) % count) + 1];
      if (f && f.src) return f.src;
      const b = set.frames[((idx - 1 - d + count) % count) + 1];
      if (b && b.src) return b.src;
    }
    return null;
  }

  function show(n) {
    const idx = ((((n - 1) % count) + count) % count) + 1;
    frame = idx;
    const set = frameSet(color);
    const src = nearestSrc(set, idx);
    if (src) img.src = src;
  }

  const colorName = rotator.querySelector('.js-rotator-color-name');

  function setActiveColor(c) {
    color = c;
    rotator
      .querySelectorAll('.js-rotator-color')
      .forEach((b) => b.classList.toggle('active', b.getAttribute('data-color') === c));
    const active = rotator.querySelector('.js-rotator-color.active');
    if (colorName && active) colorName.textContent = active.getAttribute('title') || c;
  }

  let dragging = false;
  let startX = 0;
  let startFrame = 1;
  let lastX = 0;
  let lastY = 0;

  function onDown(e) {
    preload(color);
    upgradeVisible();
    warmAllRotators();
    dragging = true;
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    lastX = startX;
    lastY = e.touches ? e.touches[0].clientY : e.clientY;
    startFrame = frame;
  }

  function onMove(e) {
    if (!dragging) return;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    const y = e.touches ? e.touches[0].clientY : e.clientY;

    // Направление текущего шага (как в Rotator на tank-borishof): вертикальный шаг
    // отдаём странице (скролл, без preventDefault), вращаем только по горизонтали.
    if (e.touches) {
      const stepX = Math.abs(x - lastX);
      const stepY = Math.abs(y - lastY);
      lastX = x;
      lastY = y;
      if (stepY > stepX) return;
    }

    const perFrame = stage.clientWidth / count;
    const delta = Math.round((x - startX) / perFrame);
    show(startFrame - delta);
    if (e.cancelable && e.touches) e.preventDefault();
  }

  function onUp() {
    if (!dragging) return;
    dragging = false;
    // Кадр, на котором остановились, мог показаться «соседним» (nearestSrc) —
    // подменяем точным, как только тот докачается
    upgradeVisible();
  }

  if (count > 1) {
    rotatorWarmers.push(upgradeVisible);
    stage.addEventListener('mouseenter', () => {
      preload(color);
      upgradeVisible();
      warmAllRotators();
    });
    stage.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    stage.addEventListener('touchstart', onDown, { passive: true });
    stage.addEventListener('touchmove', onMove, { passive: false });
    stage.addEventListener('touchend', onUp);
  }

  rotator.querySelectorAll('.js-rotator-color').forEach((btn) => {
    btn.addEventListener('click', () => {
      const c = btn.getAttribute('data-color');
      if (!c || c === color) return;
      setActiveColor(c);
      preload(color);
      show(frame);
      upgradeVisible();
    });
  });

  const selectToggle = rotator.querySelector('.js-rotator-select-toggle');
  const selectMenu = rotator.querySelector('.js-rotator-select-menu');
  const selectLabel = rotator.querySelector('.js-rotator-select-label');

  if (selectToggle && selectMenu) {
    const closeMenu = () => {
      rotator.classList.remove('deg360--open');
      selectToggle.setAttribute('aria-expanded', 'false');
    };
    selectToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = rotator.classList.toggle('deg360--open');
      selectToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', () => {
      if (rotator.classList.contains('deg360--open')) closeMenu();
    });

    rotator.querySelectorAll('.js-rotator-grade').forEach((opt) => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        closeMenu();
        const slug = opt.getAttribute('data-slug') || '';
        rotator.querySelectorAll('.js-rotator-grade').forEach((o) => o.classList.toggle('active', o === opt));
        if (selectLabel) selectLabel.textContent = opt.getAttribute('data-title') || '';
        edition = slug;

        const avail = (opt.getAttribute('data-colors') || '').split(',').filter(Boolean);
        rotator.querySelectorAll('.js-rotator-color').forEach((b) => {
          const c = b.getAttribute('data-color');
          b.hidden = avail.length > 0 && !avail.includes(c);
        });
        if (avail.length && !avail.includes(color)) {
          setActiveColor(opt.getAttribute('data-default-color') || avail[0]);
        }

        preload(color);
        show(frame);
        upgradeVisible();
      });
    });
  }
}
